// src/pages/ComingSoonPage.jsx
import React from "react";
import "./ComingSoonPage.css";
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const ComingSoonPage = () => {
  return (
    <div className="coming-soon-container"
    style={{
        //backgroundImage: "url('/images/Saffron_House.png')"
      }}>
      <nav className="hero-navbar">
        <img src="/images/Saffron_House.png" alt="Saffron House Logo" className="logo" />
        <div className="nav-buttons">
          <button className="p-project-btn">Projects</button>
          <button className="contact-btn">Contact Us <ArrowOutwardIcon className="icon" /></button>
        </div>
      </nav>

      <main className="project-hero">
        <h1 className="coming-title">Coming Soon</h1>
        <p className="coming-subtext">
          We're currently working on some beautiful spaces. Our project showcase will be live once the final touches are complete. Stay tuned!<br />
          For any queries or to learn more, feel free to <a href="#">contact us</a>.
        </p>
      </main>
    </div>
  );
};

export default ComingSoonPage;
